// Simple API client with bearer token persistence (admin + client tokens stored separately).
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_KEY = "stk_admin_token";
const CLIENT_KEY = "stk_client_token";

export const adminAuth = {
  get: () => { try { return localStorage.getItem(ADMIN_KEY); } catch { return null; } },
  set: (t) => { try { localStorage.setItem(ADMIN_KEY, t); } catch { /* ignored */ } },
  clear: () => { try { localStorage.removeItem(ADMIN_KEY); } catch { /* ignored */ } },
};

export const clientAuth = {
  get: () => { try { return localStorage.getItem(CLIENT_KEY); } catch { return null; } },
  set: (t) => { try { localStorage.setItem(CLIENT_KEY, t); } catch { /* ignored */ } },
  clear: () => { try { localStorage.removeItem(CLIENT_KEY); } catch { /* ignored */ } },
};

export function adminClient() {
  const inst = axios.create({ baseURL: API });
  inst.interceptors.request.use((cfg) => {
    const t = adminAuth.get();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return inst;
}

export function clientClient() {
  const inst = axios.create({ baseURL: API });
  inst.interceptors.request.use((cfg) => {
    const t = clientAuth.get();
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return inst;
}

export const STATUS_LABEL = {
  awaiting_payment: "Čeká na platbu",
  paid: "Platba přijata",
  invoiced: "Faktura vystavena",
  done: "Vyřízeno",
  cancelled: "Zrušeno",
};

export const STATUS_COLOR = {
  awaiting_payment: "amber",
  paid: "emerald",
  invoiced: "blue",
  done: "emerald",
  cancelled: "rose",
};

export const TIMELINE_STEPS = [
  { key: "created", label: "Objednávka vytvořena" },
  { key: "awaiting_payment", label: "Čeká na platbu" },
  { key: "paid", label: "Platba přijata" },
  { key: "invoiced", label: "Faktura vystavena" },
  { key: "done", label: "Objednávka vyřízena" },
];

export function timelineState(order) {
  // produce a list of {key, label, state: 'done'|'current'|'todo'}
  const status = order?.status || "awaiting_payment";
  const order_idx = (() => {
    if (status === "cancelled") return -1;
    if (status === "done") return 4;
    if (status === "invoiced") return 3;
    if (status === "paid") return 2;
    if (status === "awaiting_payment") return 1;
    return 1;
  })();
  return TIMELINE_STEPS.map((s, i) => {
    let state = "todo";
    if (i < order_idx) state = "done";
    else if (i === order_idx) state = "current";
    return { ...s, state };
  });
}
